import { Button } from "@ui/Button";
import { useLayoutAppKind } from "@ui/layouts/layoutProvider";
import { toast } from "@ui/molecules/Toasts/toast";
import { useContext } from "solid-js";
import {
	AddToBoardContext,
	saveClipErrorTitle,
} from "~/modules/shared/boards/boardsContext";
import { createBoardForContext } from "~/modules/shared/boards/createBoardForContext";

type Props = {
	onClose: () => void;
	projectId?: string;
	refetch?: (clipIds: string[]) => void;
};

export const AddToBoardButton = (props: Props) => {
	const [store, { setCurrentPanel, setErrors, saveClipToBoard, finishClipSave }] =
		useContext(AddToBoardContext);
	const appKind = useLayoutAppKind();

	return (
		<Button
			type="button"
			variant="primary"
			symbol="bookmark_add"
			onClick={async () => {
				const created = await createBoardForContext({
					formData: store.formData,
					appKind,
					projectId: props.projectId,
				});
				if (created.ok === false) {
					if (created.errors) {
						setErrors(created.errors);
					} else {
						toast.error({ title: "Failed to create board" });
					}
					return;
				}

				const newBoardId = created.board.id;
				const saveResult = await saveClipToBoard(newBoardId);
				if (saveResult.ok === false) {
					toast.error({
						title: saveClipErrorTitle(saveResult.reason),
					});
					return;
				}

				finishClipSave(saveResult.payload, created.board);
				const savedClipId = saveResult.payload.clipId;
				props.refetch?.(savedClipId ? [savedClipId] : []);

				toast.success({
					title: "Clip added to board",
				});
				setCurrentPanel(0);
				props.onClose();
			}}
		>
			Create and add to board
		</Button>
	);
};
